module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.current !== -1) ? _c('div', {
    staticClass: "ebitda-development"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Akkumuleret EBITDA i regnskabsåret")]), _vm._v(" "), _c('vue-apex-charts', {
    attrs: {
      "type": "bar",
      "height": 300,
      "series": _vm.series,
      "options": _vm.options
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('span', [_c('i', {
    style: ({
      background: _vm.colors.budget
    })
  }), _vm._v("Budget")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.wip && _vm.wip.total) ? _c('div', {
    staticClass: "note"
  }, [_vm._v("\n        Starter fra realiseret EBITDA i regnskabsåret indtil i dag. Værdi af opgaver for " + _vm._s(_vm._f("currency")(_vm.wip.total)) + " indgår: afsluttede, ikke fakturerede i " + _vm._s(_vm._f("moment")(_vm.months[_vm.current].month, 'MMMM')) + ", igangværende fordelt jævnt til og med " + _vm._s(_vm._f("moment")(_vm.months[_vm.months.length - 1].month, 'MMMM')) + "\n    ")]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "forecast"
  }), _vm._v("Forventet")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c902d9d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/EbitdaDevelopment.vue
// module id = 816
// module chunks = 0